const OPEN_MODAL = 'scratch-gui/modals/OPEN_MODAL';
const CLOSE_MODAL = 'scratch-gui/modals/CLOSE_MODAL';

const MODAL_BACKDROP_LIBRARY = 'backdropLibrary';
const MODAL_COSTUME_LIBRARY = 'costumeLibrary';
const MODAL_EXTENSION_LIBRARY = 'extensionLibrary';
const MODAL_LOADING_PROJECT = 'loadingProject';
const MODAL_TELEMETRY = 'telemetryModal';
const MODAL_SOUND_LIBRARY = 'soundLibrary';
const MODAL_SPRITE_LIBRARY = 'spriteLibrary';
const MODAL_SOUND_RECORDER = 'soundRecorder';
const MODAL_CONNECTION = 'connectionModal';
const MODAL_TIPS_LIBRARY = 'tipsLibrary';
const MODAL_UPLOAD_PROGRESS = 'uploadProgress';
const MODAL_COMPILE_PROGRESS = 'compileProgress';
const MODAL_DEVICE_LIBRARY = 'deviceLibrary';
const MODAL_UPDATE = 'updateModal';
const MODAL_EXAMPLE_LIBRARY = 'exampleLibrary';
const MODAL_LOGIN = 'loginModal';
const MODAL_MY_PROJECTS = 'myProjectsModal';
const MODAL_ACCOUNT_SETTINGS = 'accountSettingsModal';
const MODAL_SAVE_PROJECT = 'saveProjectModal';
const MODAL_ADMIN_PANEL = 'adminPanelModal';

const initialState = {
    [MODAL_BACKDROP_LIBRARY]: false,
    [MODAL_COSTUME_LIBRARY]: false,
    [MODAL_EXTENSION_LIBRARY]: false,
    [MODAL_LOADING_PROJECT]: false,
    [MODAL_TELEMETRY]: false,
    [MODAL_SOUND_LIBRARY]: false,
    [MODAL_SPRITE_LIBRARY]: false,
    [MODAL_SOUND_RECORDER]: false,
    [MODAL_CONNECTION]: false,
    [MODAL_UPLOAD_PROGRESS]: false,
    [MODAL_COMPILE_PROGRESS]: false,
    [MODAL_DEVICE_LIBRARY]: false,
    [MODAL_TIPS_LIBRARY]: false,
    [MODAL_UPDATE]: false,
    [MODAL_EXAMPLE_LIBRARY]: false,
    [MODAL_LOGIN]: false,
    [MODAL_MY_PROJECTS]: false,
    [MODAL_ACCOUNT_SETTINGS]: false,
    [MODAL_SAVE_PROJECT]: false,
    [MODAL_ADMIN_PANEL]: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true
        });
    case CLOSE_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false
        });
    default:
        return state;
    }
};
const openModal = function (modal) {
    return {
        type: OPEN_MODAL,
        modal: modal
    };
};
const closeModal = function (modal) {
    return {
        type: CLOSE_MODAL,
        modal: modal
    };
};
const openBackdropLibrary = function () {
    return openModal(MODAL_BACKDROP_LIBRARY);
};
const openCostumeLibrary = function () {
    return openModal(MODAL_COSTUME_LIBRARY);
};
const openExtensionLibrary = function () {
    return openModal(MODAL_EXTENSION_LIBRARY);
};
const openLoadingProject = function () {
    return openModal(MODAL_LOADING_PROJECT);
};
const openTelemetryModal = function () {
    return openModal(MODAL_TELEMETRY);
};
const openSoundLibrary = function () {
    return openModal(MODAL_SOUND_LIBRARY);
};
const openSpriteLibrary = function () {
    return openModal(MODAL_SPRITE_LIBRARY);
};
const openSoundRecorder = function () {
    return openModal(MODAL_SOUND_RECORDER);
};
const openConnectionModal = function () {
    return openModal(MODAL_CONNECTION);
};
const openUploadProgress = function () {
    return openModal(MODAL_UPLOAD_PROGRESS);
};
const openCompileProgress = function () {
    return openModal(MODAL_COMPILE_PROGRESS);
};
const openDeviceLibrary = function () {
    return openModal(MODAL_DEVICE_LIBRARY);
};
const openTipsLibrary = function () {
    return openModal(MODAL_TIPS_LIBRARY);
};
const openUpdateModal = function () {
    return openModal(MODAL_UPDATE);
};
const openExampleLibrary = function () {
    return openModal(MODAL_EXAMPLE_LIBRARY);
};
const openLoginModal = function () {
    return openModal(MODAL_LOGIN);
};
const openMyProjectsModal = function () {
    return openModal(MODAL_MY_PROJECTS);
};
const openSaveProjectModal = function () {
    return openModal(MODAL_SAVE_PROJECT);
};
const closeSaveProjectModal = function () {
    return closeModal(MODAL_SAVE_PROJECT);
};

const openAdminPanelModal = function () {
    return openModal(MODAL_ADMIN_PANEL);
};

const closeAdminPanelModal = function () {
    return closeModal(MODAL_ADMIN_PANEL);
};
const openAccountSettingsModal = function () {
    return openModal(MODAL_ACCOUNT_SETTINGS);
};
const closeExampleLibrary = function () {
    return closeModal(MODAL_EXAMPLE_LIBRARY);
};
const closeLoginModal = function () {
    return closeModal(MODAL_LOGIN);
};
const closeMyProjectsModal = function () {
    return closeModal(MODAL_MY_PROJECTS);
};
const closeAccountSettingsModal = function () {
    return closeModal(MODAL_ACCOUNT_SETTINGS);
};
const closeBackdropLibrary = function () {
    return closeModal(MODAL_BACKDROP_LIBRARY);
};
const closeCostumeLibrary = function () {
    return closeModal(MODAL_COSTUME_LIBRARY);
};
const closeExtensionLibrary = function () {
    return closeModal(MODAL_EXTENSION_LIBRARY);
};
const closeLoadingProject = function () {
    return closeModal(MODAL_LOADING_PROJECT);
};
const closeTelemetryModal = function () {
    return closeModal(MODAL_TELEMETRY);
};
const closeSpriteLibrary = function () {
    return closeModal(MODAL_SPRITE_LIBRARY);
};
const closeSoundLibrary = function () {
    return closeModal(MODAL_SOUND_LIBRARY);
};
const closeSoundRecorder = function () {
    return closeModal(MODAL_SOUND_RECORDER);
};
const closeTipsLibrary = function () {
    return closeModal(MODAL_TIPS_LIBRARY);
};
const closeConnectionModal = function () {
    return closeModal(MODAL_CONNECTION);
};
const closeUploadProgress = function () {
    return closeModal(MODAL_UPLOAD_PROGRESS);
};
const closeCompileProgress = function () {
    return closeModal(MODAL_COMPILE_PROGRESS);
};
const closeDeviceLibrary = function () {
    return closeModal(MODAL_DEVICE_LIBRARY);
};
const closeUpdateModal = function () {
    return closeModal(MODAL_UPDATE);
};
export {
    reducer as default,
    initialState as modalsInitialState,
    openBackdropLibrary,
    openCostumeLibrary,
    openExtensionLibrary,
    openLoadingProject,
    openSoundLibrary,
    openSpriteLibrary,
    openSoundRecorder,
    openTelemetryModal,
    openTipsLibrary,
    openConnectionModal,
    openUploadProgress,
    openCompileProgress,
    openDeviceLibrary,
    openUpdateModal,
    openExampleLibrary,
    openLoginModal,
    openMyProjectsModal,
    openAccountSettingsModal,
    closeExampleLibrary,
    closeLoginModal,
    closeMyProjectsModal,
    closeAccountSettingsModal,
    openSaveProjectModal,
    closeSaveProjectModal,
    openAdminPanelModal,
    closeAdminPanelModal,
    closeBackdropLibrary,
    closeCostumeLibrary,
    closeDeviceLibrary,
    closeExtensionLibrary,
    closeLoadingProject,
    closeSpriteLibrary,
    closeSoundLibrary,
    closeSoundRecorder,
    closeTelemetryModal,
    closeTipsLibrary,
    closeConnectionModal,
    closeUploadProgress,
    closeCompileProgress,
    closeUpdateModal
};
